import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const AutomationActiveInputI18n = {
  configuration: { namespace: I18nNamespace.AUTOMATION_ACTIVE_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.enabled,
  },
};
